import { render, staticRenderFns } from "./CreateInspiration.vue?vue&type=template&id=a11c011e"
import script from "./CreateInspiration.vue?vue&type=script&lang=js"
export * from "./CreateInspiration.vue?vue&type=script&lang=js"
import style0 from "./CreateInspiration.vue?vue&type=style&index=0&id=a11c011e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports